import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import { API_BASE_URL, IMG_BASE } from "../apiConfig";

export default function UpcomingEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeIndex, setActiveIndex] = useState(0);

  const getGoogleCalendarLink = (event) => {
    if (!event) return "#";
    const title = encodeURIComponent(event.title);
    const details = encodeURIComponent(event.title + " - MKS Event");
    const location = encodeURIComponent(event.location || '');
    
    // Format: YYYYMMDDTHHMMSSZ
    const startDate = new Date(event.rawDate);
    // End date defaults to 2 hours after start
    const endDate = new Date(startDate.getTime() + 2 * 60 * 60 * 1000);

    const formatGDate = (date) => date.toISOString().replace(/-|:|\.\d+/g, "").split('.')[0] + "Z";

    return `https://www.google.com/calendar/render?action=TEMPLATE&text=${title}&dates=${formatGDate(startDate)}/${formatGDate(endDate)}&details=${details}&location=${location}`;
  };

  useEffect(() => {
    const fetchUpcomingEvents = async () => {
      setLoading(true);
      try {
        const response = await fetch(`${API_BASE_URL}/api/events/upcoming`);
        const data = await response.json();
        
        const now = new Date();
        const mappedEvents = data
          .filter(item => new Date(item.EventDate) >= now)
          .map(item => ({
            id: item.EventId,
            title: item.Title,
            rawDate: item.EventDate,
            date: new Date(item.EventDate).toLocaleDateString('en-AU', {
              weekday: 'long',
              day: 'numeric',
              month: 'long',
              year: 'numeric'
            }),
          location: item.Location,
          bookingUrl: item.BookingUrl,
          image: item.ImageFile ? (item.ImageFile.split(',')[0].startsWith('http') ? item.ImageFile.split(',')[0] : IMG_BASE + item.ImageFile.split(',')[0]) : '/Comittee.jpg'
        }));
        
        setEvents(mappedEvents);
      } catch (error) {
        console.error("Error fetching upcoming events:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchUpcomingEvents();
  }, []);

  if (loading) {
    return (
      <section className="mks-events-section">
        <div className="mks-events-container">
          <div className="mks-events-top">
            <h2>UPCOMING EVENTS</h2>
            <div className="mks-events-title-line"></div>
          </div>
          <div style={{ textAlign: 'center', padding: '50px', color: '#8B0000' }}>
            <p>Loading upcoming events...</p>
          </div>
        </div>
      </section>
    );
  }

  if (events.length === 0) {
    return (
      <section className="mks-events-section">
        <div className="mks-events-container">
          <div className="mks-events-top">
            <h2>UPCOMING EVENTS</h2>
            <div className="mks-events-title-line"></div>
          </div>
          <div style={{ textAlign: 'center', padding: '50px', color: '#666' }}>
            <p>No upcoming events at the moment. Stay tuned!</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className="mks-events-section">

      <div className="mks-events-container">

        {/* HEADER */}
        <div className="mks-events-top">
          <h2>UPCOMING EVENTS</h2>
          <div className="mks-events-title-line"></div>
        </div>

        {/* FEATURED EVENT */}

        <div
          className="mks-featured-event"
          style={{
            backgroundImage: `url(${events[activeIndex].image})`
          }}
        >

          <div className="mks-featured-content">

            <h3>{events[activeIndex].title}</h3>

            <p>📅 {events[activeIndex].date}</p>

            <p>📍 {events[activeIndex].location}</p>

            <div className="mks-featured-buttons">
              {events[activeIndex].bookingUrl ? (
                <a 
                  href={events[activeIndex].bookingUrl} 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="primary-btn-link"
                >
                  <button className="primary">Register Now</button>
                </a>
              ) : (
                <button className="primary">Register Now</button>
              )}

              <a 
                href={getGoogleCalendarLink(events[activeIndex])} 
                target="_blank" 
                rel="noopener noreferrer"
                className="secondary-btn-link"
              >
                <button className="secondary">Add to Calendar</button>
              </a>

              {/* <button className="tertiary">View More</button> */}

            </div>

          </div>

        </div>


        {/* THUMBNAIL SLIDER */}
        <div className="mks-thumbnail-slider">
          <Swiper
            modules={[Navigation]}
            navigation
            loop={true}
            spaceBetween={20}
            slidesPerView={4}
            breakpoints={{
              320: { slidesPerView: 1 },
              600: { slidesPerView: 2 },
              900: { slidesPerView: 3 },
              1200: { slidesPerView: 4 }
            }}
          >
            {events.map((event, index) => (
              <SwiperSlide key={index}>
                <img
                  src={event.image}
                  alt={event.title}
                  className={`mks-thumb ${activeIndex === index ? "active" : ""}`}
                  onClick={() => setActiveIndex(index)}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>


        {/* VIEW ALL */}

        <div className="mks-view-all">

          <a href="/events">View All Events →</a>

        </div>

      </div>

    </section>
  );
}